import { ActivityCardData } from '../types/dashboard';
import { CARD_CONFIGS } from '../constants/dashboard';
import { CASES } from '../constants/common';

export const formatCount = (value?: number): string =>
  typeof value === 'number' ? `${value.toLocaleString()}${CASES}` : '-';

export const makeCard = (
  id: string,
  title: string,
  value: string,
  coverImage?: string
): ActivityCardData => ({
  id,
  title,
  value,
  ...(coverImage && { coverImage }),
});

export const makeEmptyCards = (): ActivityCardData[] =>
  CARD_CONFIGS.map(({ id, title }) => makeCard(id, title, '-'));
